import React from 'react';
import { Button, styled } from '@mui/material';

const ButtonWrapper = ({ children, ...rest }) => (
  <StyledButton variant='outlined' {...rest}>
    {children}
  </StyledButton>
);

export default ButtonWrapper;

const StyledButton = styled(Button)(({ theme, size }) => ({
  border: `2px solid ${theme.palette.secondary.main} !important`,
  color: theme.palette.secondary.main,
  textTransform: 'capitalize',
  backgroundColor: 'transparent',
  padding: size === 'large' ? theme.spacing(1.5, 3) : theme.spacing(0.8, 2),

  '&:hover': {
    backgroundColor: theme.palette.secondary.tint,
  },
}));
